import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'ccd-document-dialog',
  template: require('./document-dialog.component.html'),
  styles: [require('../action-dialog.component.scss')]
})
export class DocumentDialogComponent implements OnInit {

  result: string;

  constructor(private matDialogRef: MatDialogRef<DocumentDialogComponent>) {}

  ngOnInit() {
  }

  replace() {
    this.result = 'Replace';
    this.matDialogRef.close(this.result);
  }
  cancel() {
    this.result = 'Cancel';
    this.matDialogRef.close(this.result);
  }
}
